window.jQuery = require('jquery');
require('bootstrap-webpack');

import Vue from 'vue';

Vue.config.debug = true;

new Vue({
    el: 'body',
    components: {
        App: require('./App')
    }
});



/** WEBPACK FOOTER **
 ** D:/xampp/htdocs/projects/resume/src/main.js
 **/